import { COLOURS } from './colours';
const styleOverrides = {
    root: {
        backgroundColor: COLOURS.White,
        color: COLOURS.Primary,
    },
};
export const MuiAppBar = {
    styleOverrides,
};
